export default __webpack_public_path__ + "static/feature-14373163e938ec84f1b1fed0928df3a0.png";